module.exports = __webpack_public_path__ + "img/secure-login.056e55fd.svg";